<template>
    <v-container fluid>
        <v-card class="pa-4" elevation="2">
            <v-row class="align-center">
                <v-col class="headline mb-4">
                    <h2>Campañas de Odoo para la web de Cliente</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn color="primary" @click="importCampaigns">Importar</v-btn>
                    <v-btn
                        color="secondary"
                        v-if="selected.length"
                        @click="openEditModal"
                        style="margin-left:10px"
                        >
                        Editar seleccionados
                    </v-btn>

                </v-col>
            </v-row>

            <!-- AVISOS -->
            <v-snackbar
                v-model="snackbar"
                :color="snackbarColor"
                timeout="3000"
                multi-line
                >
                {{ snackbarMessage }}
            </v-snackbar>


            <!-- 🔍 Camp de cerca -->
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field
                        v-model="search"
                        label="Buscar campañas..."
                        prepend-inner-icon="mdi-magnify"
                        clearable
                    ></v-text-field>
                </v-col>
            </v-row>

            <!-- 📋 Taula de dades -->
            <v-data-table
                v-model="selected"
                :items="campaign"
                :headers="headers"
                :search="search"
                item-value="id"
                show-select
                return-object
                class="elevation-1"
            >

                <template #item.img="{ item }">
                    <v-img
                        :src="item.img || ''"
                        max-height="40"
                        max-width="120"
                        cover
                        class="rounded"
                    />
                </template>

                <!-- Client odoo -->
                <template #item.idClient="{ item }">
                    <span class="d-flex align-center">
                        {{ item.idClient }}

                        <a
                        :href="`https://traycco.odoo.rgbconsulting.com/web#id=${item.idClient}&cids=1&menu_id=72&action=78&model=res.partner&view_type=form`"
                        target="_blank"
                        rel="noopener"
                        class="ml-2"
                        >
                        <v-icon size="18">mdi-open-in-new</v-icon>
                        </a>
                    </span>
                </template>

                <!-- Campanya odoo -->
                <template #item.idCamp="{ item }">
                    <span class="d-flex align-center">
                        {{ item.idCamp }}

                        <a
                        :href="`https://traycco.odoo.rgbconsulting.com/web#id=${item.idCamp}&cids=1&menu_id=335&action=455&model=traycco.campaign&view_type=form`"
                        target="_blank"
                        rel="noopener"
                        class="ml-2"
                        >
                        <v-icon size="18">mdi-open-in-new</v-icon>
                        </a>
                    </span>
                </template>



                <template #item.user="{ item }">
                    {{ (!item.user || item.user === 'null' || item.user === 'undefined') ? '' : item.user }}
                </template>

                <template #item.pwd="{ item }">
                    {{ (!item.pwd || item.pwd === 'null' || item.pwd === 'undefined') ? '' : item.pwd }}
                </template>
            </v-data-table>
        </v-card>

        <!-- MODAL D'EDICIÓ -->
        <v-dialog v-model="editDialog" max-width="500">
            <v-card>
                <v-card-title class="headline">Editar agrupación</v-card-title>
                <v-card-text>
                <v-text-field
                    v-model="newGroupedDescription"
                    label="Nueva descripción agrupada"
                    autofocus
                />

                <v-file-input
                    v-model="newImageFile"
                    label="Seleccionar nueva imagen"
                    accept="image/*"
                    prepend-icon="mdi-image"
                    clearable
                    show-size
                />
                </v-card-text>
                <v-card-actions>
                <v-spacer />
                <v-btn text @click="editDialog = false">Cancelar</v-btn>
                <v-btn color="primary" @click="saveGroupedDescription">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useSnackbar } from '@/composables/useSnackbar'

const {
  snackbar,
  snackbarMessage,
  snackbarColor,
  showSnackbar
} = useSnackbar()

const campaign = ref([])
const search = ref('')

const headers = [
    { title: 'ID', value: 'id' , sortable: true},
    { title: 'Imagén del folleto', value: 'img' , sortable: true},
    { title: 'ID Client', value: 'idClient' , sortable: true},
    { title: 'ID Odoo', value: 'idCamp' , sortable: true},
    { title: 'Descripción', value: 'descripcio' , sortable: true},
    { title: 'Descripción para agrupar', value: 'desc_agrupada' , sortable: true},
    { title: 'Inicio', value: 'start_date' , sortable: true},
    { title: 'Fin', value: 'end_date' , sortable: true},
    { title: 'Servicio', value: 'service_name' , sortable: true},
    { title: 'Estado', value: 'state' , sortable: true},
    { title: 'Cantidad', value: 'quantity' , sortable: true},
    { title: 'Usuario', value: 'user' , sortable: true},
    { title: 'Contraseña', value: 'pwd' , sortable: true},
    { title: 'Acciones', value: 'acciones', sortable: false },
]


const selected = ref([]) // línies seleccionades
const editDialog = ref(false)
const newGroupedDescription = ref('')
const newImageFile = ref(null)


const openEditModal = () => {
  newGroupedDescription.value = ''
  editDialog.value = true
}

const saveGroupedDescription = async () => {
  try {
    for (const item of selected.value) {
      const formData = new FormData()
      /*if (newGroupedDescription.value && newGroupedDescription.value.trim() !== '') {
        formData.append('desc_agrupada', newGroupedDescription.value)
      }*/
      formData.append('desc_agrupada', newGroupedDescription.value) // Permeto descripció buida

      if (newImageFile.value) {
        formData.append('img', newImageFile.value)
      }

      await axios.post(`/api/campaignsWeb/by-id/${item.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    }

    editDialog.value = false
    newImageFile.value = null
    showSnackbar('Actualitzado correctamente', 'success')
    await fetchCampaigns()
    selected.value = []
  } catch (e) {
    console.error('Error al guardar les descripcions:', e)
    showSnackbar('Error al guardar las descripcione', 'error')
  }
}

const fetchCampaigns = async () => {
  try {
    const token = localStorage.getItem('token')
    if (!token) throw new Error('Sin token')

    const { data } = await axios.get('/api/campaignsWeb', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      responseType: 'json',

    })

    // Asegura que sea un array para la DataTable
    const items = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])
    if (!Array.isArray(items)) {
      throw new Error('La API no devolvió un array')
    }

    campaign.value = items
  } catch (e) {
    console.error('Error loading Campanyes:', e)
    error.value = e.response?.data?.message || e.message || 'Error cargando las campañas'

    if (e.response?.status === 401) {
      localStorage.removeItem('token')
      await router.push('/')
    }
  }
}

const importCampaigns = async () => {
    try {
        await axios.get('/api/ImportCampaignWeb',  {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        await fetchCampaigns()
        showSnackbar('Campañas importadas correctamente', 'success')
    } catch (e) {
        console.error('Error al importar campañas:', e)
        showSnackbar('Error al importar campañas desde Odoo', 'error')
    }
}


onMounted(fetchCampaigns)

</script>
